import type { Session } from "@supabase/supabase-js";
import { signOut } from "../auth/auth";
import { h, mount } from "../lib/dom";

export type RouteName = "dashboard" | "editor" | "requests" | "ledger";

export interface ShellOptions {
  session: Session;
  route: RouteName;
  onNavigate: (route: RouteName, params?: Record<string, string>) => void;
}

export function renderShell(root: HTMLElement, opts: ShellOptions, body: HTMLElement): void {
  const nav = h(
    "nav",
    { class: "shell-nav", "aria-label": "Primary" },
    navLink("Drafts", opts.route === "dashboard", () => opts.onNavigate("dashboard")),
    navLink("New review", opts.route === "editor", () => opts.onNavigate("editor")),
    navLink("Submissions", opts.route === "requests", () => opts.onNavigate("requests")),
    navLink("Ledger", opts.route === "ledger", () => opts.onNavigate("ledger")),
  );

  const header = h(
    "header",
    { class: "shell-header" },
    h(
      "div",
      { class: "shell-header-inner" },
      h(
        "a",
        {
          class: "shell-logo",
          href: "#",
          onclick: (e: Event) => {
            e.preventDefault();
            opts.onNavigate("dashboard");
          },
        },
        "MyPickyFork ",
        h("span", { class: "shell-logo-faded" }, "Admin"),
      ),
      nav,
      h(
        "div",
        { class: "shell-meta" },
        h("span", { class: "shell-email" }, opts.session.user.email ?? ""),
        h(
          "button",
          {
            class: "btn btn-ghost btn-sm",
            type: "button",
            onclick: async () => {
              await signOut();
            },
          },
          "Sign out",
        ),
      ),
    ),
  );

  mount(root, header, body);
}

function navLink(label: string, active: boolean, onClick: () => void): HTMLElement {
  return h(
    "a",
    {
      class: `shell-nav-link${active ? " is-active" : ""}`,
      href: "#",
      "aria-current": active ? "page" : null,
      onclick: (e: Event) => {
        e.preventDefault();
        onClick();
      },
    },
    label,
  );
}
